export const QUALITIES = {
    CAMARA: 1,
    FABRICA: 2,
    GRADO_2: 3,
    TAL_CUAL: 4,
}

//QUALITY (calidad)
export const quality = {
    '-1': '--',
    0: "--",
    1: "Camara",
    2: "Fabrica",
    3: "Grado 2",
    4: "Tal cual"
}